// extracted by mini-css-extract-plugin
module.exports = {"header":"SignUpHeader_header__guTWe","left":"SignUpHeader_left__yLYNS","right":"SignUpHeader_right__NATi3","title":"SignUpHeader_title__ViNfT"};